import { lazy } from 'react';

export const TournamentFormPageAsync = lazy(() =>
  import('./TournamentFormPage').then((m) => ({ default: m.TournamentFormPage })),
);
